exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "    .header {\n    color: white;\n    background-color: #2d3349 !important;\n    /* position: fixed;\n    top: 0;\n    right: 0;\n    left: 0; */\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/dialogs/reset-password-dialog/reset-password-dialog.component.css
// module id = ../../../../../src/app/dialogs/reset-password-dialog/reset-password-dialog.component.css
// module chunks = main